{
  "/intro": {
    "_section": {
      "type": [
        "singlepage",
        "multipage"
      ]
    },
    "_elements": {
      "header": {},
      "p": {},
      "br": {}
    },
    "page": {}
  },
  "/welcome": {
    "_section": {
      "watchedIntro": [
        "true"
      ]
    },
    "_elements": {
      "header": {},
      "hr": {},
      "p": {},
      "br": {},
      "watch-now-button": {},
      "next-button": {}
    },
    "page": {
      "classes": [
        "welcome-text-container",
        "wide welcome-text-container"
      ]
    }
  },
  "/intro-video": {
    "_section": {},
    "_elements": {},
    "video": {
      "duration": [
        "2:13"
      ],
      "vimeoId": [
        "436778005"
      ]
    }
  },
  "/read": {
    "_section": {},
    "_elements": {
      "header": {
        "classes": [
          "how-long"
        ]
      },
      "p": {},
      "br": {},
      "listitem": {},
      "hr": {}
    },
    "page": {
      "classes": [
        "welcome-text-container",
        "welcome-text-container wide",
        "whatsnext"
      ]
    }
  },
  "/video": {
    "_section": {},
    "_elements": {
      "header": {},
      "p": {}
    },
    "video": {
      "duration": [
        "01:55"
      ],
      "vimeoId": [
        "1085604102"
      ],
      "isReplay": [
        "true"
      ],
      "reference": [
        "history"
      ]
    }
  },
  "/rating/audio": {
    "_section": {
      "type": [
        "audio"
      ]
    },
    "_elements": {
      "header": {}
    },
    "page": {},
    "rating-component": {
      "id": [
        "1",
        "2",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "3",
        "4",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "5",
        "6"
      ],
      "audio": [
        "/Experienced24/BFN.mp3"
      ],
      "video": [
        "1018220306"
      ],
      "thumbnail": [
        "/Experienced24/BFN.png"
      ],
      "duration": [
        "0:07"
      ],
      "gender": [
        "F",
        "M"
      ],
      "race": [
        "A",
        "B",
        "E",
        "W"
      ],
      "lowersocio": [
        "N",
        "Y"
      ]
    }
  },
  "/rating/video": {
    "_section": {
      "type": [
        "video"
      ]
    },
    "_elements": {
      "header": {}
    },
    "page": {},
    "rating-component": {
      "id": [
        "1",
        "2",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "3",
        "4",
        "41",
        "42",
        "43",
        "44",
        "45",
        "46",
        "5",
        "6"
      ],
      "audio": [
        "/Experienced24/BFN.mp3"
      ],
      "video": [
        "1018220306"
      ],
      "thumbnail": [
        "/Experienced24/BFN.png"
      ],
      "duration": [
        "0:07"
      ],
      "gender": [
        "F",
        "M"
      ],
      "race": [
        "A",
        "B",
        "E",
        "W"
      ],
      "lowersocio": [
        "N",
        "Y"
      ]
    }
  },
  "/rating/results": {
    "_section": {
      "showBias": [
        "false",
        "true"
      ]
    },
    "_elements": {
      "question": {},
      "header": {},
      "p": {}
    },
    "page": {},
    "above-ratings": {},
    "below-ratings": {}
  },
  "/quiz": {
    "_section": {},
    "_elements": {
      "question": {},
      "answer-item": {
        "correct": [
          "true"
        ]
      }
    },
    "page": {}
  },
  "/expand": {
    "_section": {},
    "_elements": {
      "header": {},
      "p": {}
    },
    "statement": {},
    "page": {}
  },
  "/reminders": {
    "_section": {
      "dontEmailActions": [
        "true"
      ],
      "type": [
        "actions"
      ],
      "images": [
        "general2"
      ],
      "itemName": [
        "Actions"
      ],
      "requiredToSelect": [
        "1"
      ]
    },
    "_elements": {
      "header": {},
      "p": {},
      "action-button-example": {}
    },
    "action": {
      "image": [
        "01.png",
        "02.png",
        "03.png",
        "04.png",
        "05.png",
        "07.png",
        "08.png",
        "09.png",
        "10.png",
        "11.png",
        "12.png",
        "13.png",
        "14.png",
        "15.png",
        "16.png",
        "17.png",
        "slide_intro.png"
      ]
    }
  },
  "/reflection": {
    "_section": {},
    "_elements": {
      "header": {
        "classes": [
          "bold"
        ]
      },
      "p": {},
      "br": {},
      "reflection-image": {},
      "textarea": {
        "placeholder": [
          "Please enter your thoughts to continue"
        ]
      }
    },
    "page": {
      "intro": [
        "true"
      ],
      "classes": [
        "reflection-intro"
      ]
    }
  },
  "/send-reflections": {
    "_section": {
      "sendgridTemplateId": [
        "d-b2d314b42d554d5a940c2be40e1113b5"
      ]
    },
    "_elements": {
      "header": {},
      "p": {},
      "br": {},
      "yes-no": {
        "sendTo": [
          "hemisphere",
          "self"
        ]
      }
    },
    "page": {}
  },
  "/cpd-certificate/name": {
    "_section": {},
    "_elements": {
      "header": {},
      "p": {},
      "helper": {}
    },
    "page": {}
  },
  "/feedback": {
    "_section": {},
    "_elements": {
      "header": {
        "optional": [
          "true"
        ]
      },
      "reflection-image": {},
      "p": {},
      "dropdown": {
        "placeholder": [
          "Please select"
        ]
      },
      "answer-item": {},
      "likert": {
        "scale": [
          "10"
        ],
        "leftLabel": [
          "No benefit at all",
          "Not at all likely",
          "Strongly disagree"
        ],
        "rightLabel": [
          "Extremely likely",
          "Strongly agree",
          "Very likely",
          "Would benefit a lot"
        ]
      },
      "textarea": {
        "placeholder": [
          "Enter your answer.",
          "Enter your answer. Please note feedback may be shared with your employer, anonymously."
        ]
      },
      "email": {
        "placeholder": [
          "Enter your email address. We will not share your details or contact you for any other reason."
        ]
      }
    },
    "page": {
      "hidePageNumbers": [
        "true"
      ],
      "classes": [
        "align-top",
        "has-reflection-image"
      ],
      "align-items": [
        "top"
      ]
    }
  },
  "/complete": {
    "_section": {
      "emailActions": [
        "true"
      ]
    },
    "_elements": {
      "header": {},
      "hr": {},
      "p": {}
    },
    "page": {
      "haveNextButton": [
        "false"
      ],
      "haveContentLibraryButton": [
        "true"
      ],
      "classes": [
        "welcome-text-container wide"
      ]
    }
  }
}
